export { Moving } from './moving.page';
